import * as angular from 'angular';

import { ComponentDefinition, KeyValuePair } from '../../models/index';
import { MailingJobCondition } from '../../models/mailing/MailingJobCondition';

class MailingJobConditionPickerController implements angular.IComponentController {
    static $inject = [];

    conditions: KeyValuePair<MailingJobCondition, string>[] = [
        { key: MailingJobCondition.None, value: 'None' },
        { key: MailingJobCondition.NotYetApproved, value: 'Not yet approved' }
    ];
}

export const wtMailingJobConditionPicker: ComponentDefinition = {
    componentId: 'wtMailingJobConditionPicker',
    controller: MailingJobConditionPickerController,
    template: require('./mailingJobConditionPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        isDisabled: '<?',
        model: '=',
        name: '@'
    }
};